import { readCookie } from "./readCookie.ts";

/**
 * Extracts the GA4 session ID from the `_ga_<container>` cookie.
 *
 * The cookie has the shape `GS<version>.<n>.<sessionId>.<...>` (e.g.
 * `GS1.1.1234567890.5.0.0.0.0`). GA4 stores the session ID in the third
 * dot-separated segment.
 *
 * Used as a fallback for the session ID in Walker OS events when the
 * collector hasn't populated `event.user.session` yet.
 */
export function getGASessionId(): string | undefined {
  const value = readCookie((name) => name.startsWith("_ga_"));
  if (!value) return undefined;

  const parts = value.split(".");
  return parts.length >= 3 ? parts[2] : undefined;
}
